import { Box } from '@mui/material';
import { FC } from 'react';
import Dropdown from '../dropdown';
import { IOptions } from './date-picker.types';

interface ITimeSelectorProps {
	error?: boolean;
	minutesOptions?: IOptions[];
	hoursOptions?: IOptions[];
	hour?: string;
	setHour: (value: string) => void;
	setMinute?: (value: string) => void;
	minute?: string;
}

const TimeSelector: FC<ITimeSelectorProps> = ({
	error = false,
	minutesOptions = [],
	hoursOptions = [],
	hour,
	setHour,
	setMinute,
	minute,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				flexGrow: 1,
				gap: 2,
				mt: 2,
				mx: { xs: 'auto', sm: 2 },
			}}
		>
			<Box sx={{ width: '100%' }}>
				<Dropdown
					error={error}
					data={hoursOptions}
					id='hour'
					label='Hour'
					name='hour'
					value={hour}
					onChange={(x) => setHour(x as string)}
					isTime
				/>
			</Box>
			<Box sx={{ width: '100%' }}>
				<Dropdown
					error={error}
					data={minutesOptions}
					id='minute'
					label='Minute'
					name='minute'
					value={minute}
					onChange={(x) => {
						if (setMinute) {
							setMinute(x as string);
						}
					}}
					isTime
				/>
			</Box>
		</Box>
	);
};

export default TimeSelector;
